import React, { useState, useEffect } from 'react';
import GeneralSettings from './GeneralSettings';
import ResponsiveSettings from './ResponsiveSettings';

const AdaptiveSettings = (props) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Fonction pour détecter si l'écran est mobile
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // 768px = breakpoint tablette
    };

    // Vérifier au chargement
    checkScreenSize();

    // Écouter les changements de taille d'écran
    window.addEventListener('resize', checkScreenSize);

    // Nettoyer l'écouteur
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  // Afficher la version responsive sur mobile, l'ancienne version sur desktop
  return isMobile ? (
    <ResponsiveSettings {...props} />
  ) : (
    <GeneralSettings {...props} />
  );
};

export default AdaptiveSettings;
